import styled, { keyframes } from 'styled-components';

const NAVIGATION_HEIGHT = 58;

export const growIndicator = keyframes`
	from {
		width: 0px;
		opacity: 0;
	}
	to {
		width: 20px;
		opacity: 1;
	}
`;

export const TabsWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(${props => props.tabNumber}, 1fr);
	align-items: center;
	width: 100%;
	padding: 8px 32px;
	overflow-x: scroll;
	-ms-overflow-style: none;  /* IE and Edge */
	scrollbar-width: none;  /* Firefox */

	&::-webkit-scrollbar {
		display: none;
	}

	@media ${props => props.theme.device.lgDesktop} {
		${props => !props.isFixed && 'padding: 8px 200px;'}
	}

	@media ${props => props.theme.device.desktop} {
		${props => !props.isFixed && 'padding: 8px 150px;'}
	}
`;

export const TabOption = styled.div`
	position: relative;
	text-align: center;
	cursor: pointer;
	color: #FFF;
	opacity: ${props => (props.isActive ? 1 : 0.6)};
	white-space: nowrap;

	&:after {
		content: '';
		display: ${props => (props.isActive ? 'block' : 'none')};
		height: 4px;
		position: absolute;
		bottom: -4px;
		left: 50%;
		border-radius: 50px;
		background: #FFF;
		transform: translate(-50%, 100%);
		animation: ${growIndicator} 0.2s ease-in-out forwards;
	}

	@media ${props => props.theme.device.mobile} {
		&:not(:last-child) {
			margin-right: 20px;
		}
	}
`;

export const ContentWrapper = styled.div`
	display: flex;
	justify-content: center;
	// Need to fix navigation bar to prevent from calculating offset error.
	height: ${NAVIGATION_HEIGHT}px;
`;
